export default __webpack_public_path__ + "mytributes/images/where-memories-live.svg";